import { render, staticRenderFns } from "./WidgetUndoneActs.vue?vue&type=template&id=63575f51&"
import script from "./WidgetUndoneActs.vue?vue&type=script&lang=js&"
export * from "./WidgetUndoneActs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports